<template>
  <div class="update-popup">
    <PopUp
      :pop-up-active="_popupActive"
      notice
      :clickOutsideClose="false"
      :title="_popupTitle"
      @click="$_popupClose()"
    >
      <LlCancelPopupContent :cancel-text="_popupContent" />
    </PopUp>
  </div>
</template>
<script>
export default {
  name: "UpdatePopup",
  computed: {
    _popupActive() {
      return this.$store.state.updatepopup.isUpdatePopupActive;
    },
    _popupContent() {
      return this.$store.state.updatepopup.content;
    },
    _popupTitle() {
      return this.$store.state.updatepopup.title;
    },
  },
  methods: {
    $_popupClose() {
      this.$store.dispatch("updatepopup/closeUpdatePopup");
    },
  },
};
</script>
<style lang="scss" scoped>
</style>